// extracted by mini-css-extract-plugin
export default {"certificate":"certificate_certificate__JmlsW","image":"certificate_image__CPbJn","name":"certificate_name__jHniH"};